module.exports = __webpack_public_path__ + "img/Flag_of_Niue.ce971e9a.svg";